import { Box, IconButton, Tooltip, VStack } from '@chakra-ui/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LuCircleHelp } from 'react-icons/lu'
import RecentActivity from '../../components/RecentActivity'
import HomeHeader from '../../components/HomeHeader'
import ActivityDashboard from '../../components/ActivityDashboard'
import InProgressCases from '../../components/InProgressCases'
import HomeOnboardingTour from '../../components/Home/HomeOnboardingTour'

export default function Home() {
  const { t } = useTranslation()
  // Phase semantics in HomeOnboardingTour: -1 closed, 0 welcome modal,
  // 1..N coachmarks, N+1 final modal. Held here so the ? button can open
  // the tour from any home re-render.
  const [tourPhase, setTourPhase] = useState<number>(-1)
  return (
    <Box
      minH="100vh"
      bg="gray.50"
      p={{ base: 4, md: 6, lg: 8 }}
      overflow="auto"
      position="relative"
    >
      {/* Replay-tour pill — small, top-right, doesn't fight the HomeHeader */}
      <Box position="absolute" top={{ base: 3, md: 5 }} right={{ base: 3, md: 6 }} zIndex={2}>
        <Tooltip label={t('home.tour.replayHint', { defaultValue: 'Relancer la visite guidée' })} placement="left" hasArrow>
          <IconButton
            aria-label={t('home.tour.replayHint', { defaultValue: 'Relancer la visite guidée' })}
            icon={<LuCircleHelp />}
            onClick={() => setTourPhase(0)}
            size="sm"
            variant="ghost"
            color="white"
            bg="whiteAlpha.200"
            backdropFilter="blur(10px)"
            _hover={{ bg: 'whiteAlpha.400' }}
            borderRadius="full"
          />
        </Tooltip>
      </Box>
      <VStack spacing={8} align="stretch" maxW="1400px" mx="auto">

        <HomeHeader />

        {/* Cases in progress / pending — replaces the legacy "Accès rapide"
            module cards so the home page surfaces actionable work first. */}
        <InProgressCases />

        {/* Activity dashboard — charts + KPIs */}
        <ActivityDashboard />

        {/* Recent Activity */}
        <Box
          bg="white"
          borderRadius="2xl"
          boxShadow="0 10px 30px -12px rgba(99, 102, 241, 0.10)"
          border="1px solid"
          borderColor="gray.100"
          p={{ base: 5, md: 6 }}
          position="relative"
          overflow="hidden"
        >
          {/* Top gradient strip — matches the dashboard's design language. */}
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            h="4px"
            bgGradient="linear(to-r, indigo.400, purple.400, pink.400)"
          />
          {/* Decorative radial blob */}
          <Box
            position="absolute"
            top="-100px"
            right="-100px"
            w="220px"
            h="220px"
            borderRadius="full"
            bgGradient="radial(rgba(168,85,247,0.08), transparent 70%)"
            pointerEvents="none"
          />
          <RecentActivity />
        </Box>

      </VStack>

      {/* First-visit guided tour. Auto-opens once per device after the AI
          Act notice is acknowledged. Re-launchable via the ? button above. */}
      <HomeOnboardingTour phase={tourPhase} setPhase={setTourPhase} />
    </Box>
  )
}
